import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPage = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="privacy-hero py-5" style={{
        background: 'var(--gradient-hero)',
        color: 'white',
        paddingTop: '180px',
        position: 'relative',
        overflow: 'hidden',
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center'
      }}>
        {/* Background Pattern */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 20% 80%, var(--accent-500) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, var(--accent-400) 0%, transparent 50%)
          `,
          opacity: '0.06',
          zIndex: 1
        }}></div>

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="row">
            <div className="col-lg-8 mx-auto text-center">
              <h1 style={{
                fontSize: 'clamp(2.5rem, 5vw, 4rem)',
                fontWeight: '800',
                marginBottom: '1rem',
                color: 'var(--primary-50)',
                textShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
              }}>
                Privacy Policy
              </h1>
              <p style={{
                fontSize: '1.2rem',
                color: 'rgba(255, 255, 255, 0.9)',
                maxWidth: '600px',
                margin: '0 auto',
                fontWeight: '500'
              }}>
                Last updated: January 15, 2025
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-5" style={{ 
        background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
        position: 'relative'
      }}>
        {/* Background Pattern */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 10% 20%, rgba(14, 165, 233, 0.03) 0%, transparent 50%),
            radial-gradient(circle at 90% 80%, rgba(14, 165, 233, 0.02) 0%, transparent 50%)
          `,
          zIndex: 1
        }}></div>

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <div style={{
                background: 'rgba(255, 255, 255, 0.9)',
                padding: '3rem',
                borderRadius: '24px',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.08)',
                border: '1px solid rgba(14, 165, 233, 0.1)',
                backdropFilter: 'blur(10px)'
              }}>
                <div style={{ color: '#374151', lineHeight: '1.8' }}>
                                    <h2 style={{ color: '#334155', marginBottom: '1.5rem', fontWeight: '700' }}>
                    1. Introduction
                   </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    <span style={{ color: '#0ea5e9', fontWeight: '600' }}>Vallen AI</span> ("we," "our," "us," or "<span style={{ color: '#0ea5e9', fontWeight: '600' }}>Vallen AI</span>") is committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, process, store, and protect your information when you visit our website, use our AI and technology services, or interact with us in any capacity.
                  </p>
                  <p style={{ marginBottom: '1.5rem' }}>
                    As an AI consulting and development company specializing in generative AI, machine learning, and custom software solutions, we handle various types of data, including business information, technical specifications, and potentially sensitive data related to AI model training and deployment. This policy outlines our commitment to responsible data handling practices.
                  </p>

                                    <h2 style={{ color: '#334155', marginBottom: '1.5rem', fontWeight: '700' }}>
                    2. Information We Collect
                   </h2>
                  
                  <h3 style={{ color: '#374151', marginBottom: '1rem', fontWeight: '600' }}>2.1 Personal Information</h3>
                  <p style={{ marginBottom: '1rem' }}>
                    We collect personal information that you voluntarily provide to us, including:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li><strong>Contact Information:</strong> Name, email address, phone number, company name, job title</li>
                    <li><strong>Business Information:</strong> Company size, industry, project requirements, technical specifications</li>
                    <li><strong>Communication Data:</strong> Messages, feedback, support requests, and other communications</li>
                    <li><strong>Account Information:</strong> Login credentials, preferences, and settings (if applicable)</li>
                    <li><strong>Payment Information:</strong> Billing details, payment history, and financial information</li>
                  </ul>

                  <h3 style={{ color: '#374151', marginBottom: '1rem', fontWeight: '600' }}>2.2 Technical and Usage Data</h3>
                  <p style={{ marginBottom: '1rem' }}>
                    When you interact with our website and services, we automatically collect:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li><strong>Device Information:</strong> IP address, browser type, operating system, device identifiers</li>
                    <li><strong>Usage Analytics:</strong> Pages visited, time spent, click patterns, and navigation behavior</li>
                    <li><strong>Performance Data:</strong> Website performance metrics, error logs, and technical diagnostics</li>
                    <li><strong>Cookies and Tracking:</strong> Session data, preferences, and authentication tokens</li>
                  </ul>

                  <h3 style={{ color: '#374151', marginBottom: '1rem', fontWeight: '600' }}>2.3 AI and Machine Learning Data</h3>
                  <p style={{ marginBottom: '1rem' }}>
                    In the course of providing AI and ML services, we may handle:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li><strong>Training Data:</strong> Datasets provided by clients for model training and development</li>
                    <li><strong>Model Outputs:</strong> Generated content, predictions, and AI model results</li>
                    <li><strong>Performance Metrics:</strong> Model accuracy, efficiency, and optimization data</li>
                    <li><strong>Technical Specifications:</strong> Architecture details, configuration parameters, and system requirements</li>
                  </ul>

                                    <h2 style={{ color: '#334155', marginBottom: '1.5rem', fontWeight: '700' }}>
                    3. How We Use Your Information
                   </h2>
                  <p style={{ marginBottom: '1rem' }}>
                    We use the collected information for the following purposes:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li><strong>Service Delivery:</strong> Providing AI consulting, development, and implementation services</li>
                    <li><strong>Project Management:</strong> Coordinating development efforts, tracking progress, and ensuring quality</li>
                    <li><strong>Communication:</strong> Responding to inquiries, providing support, and sending project updates</li>
                    <li><strong>Business Development:</strong> Understanding client needs and improving our service offerings</li>
                    <li><strong>Quality Assurance:</strong> Testing, validating, and optimizing AI models and software solutions</li>
                    <li><strong>Legal Compliance:</strong> Meeting regulatory requirements and contractual obligations</li>
                    <li><strong>Security:</strong> Protecting against fraud, unauthorized access, and security threats</li>
                  </ul>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    4. Data Processing and AI Ethics
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    As an AI-focused company, we are committed to responsible AI practices:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li><strong>Bias Mitigation:</strong> We implement measures to identify and reduce bias in AI models</li>
                    <li><strong>Transparency:</strong> We provide clear explanations of how AI systems make decisions</li>
                    <li><strong>Data Minimization:</strong> We collect only the data necessary for specific purposes</li>
                    <li><strong>Human Oversight:</strong> We maintain human supervision of AI systems where appropriate</li>
                    <li><strong>Regular Audits:</strong> We conduct periodic reviews of our AI systems and data practices</li>
                  </ul>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    5. Information Sharing and Disclosure
                  </h2>
                  <p style={{ marginBottom: '1rem' }}>
                    We do not sell, trade, or rent your personal information to third parties. We may share information in the following circumstances:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li><strong>With Your Consent:</strong> When you explicitly authorize us to share your information</li>
                    <li><strong>Service Providers:</strong> With trusted partners who assist in delivering our services (cloud providers, development tools, etc.)</li>
                    <li><strong>Legal Requirements:</strong> When required by law, court order, or government regulation</li>
                    <li><strong>Business Transfers:</strong> In connection with mergers, acquisitions, or asset sales</li>
                    <li><strong>Protection of Rights:</strong> To protect our rights, property, or safety, or that of our clients</li>
                  </ul>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    6. Data Security and Protection
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    We implement comprehensive security measures to protect your information:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li><strong>Encryption:</strong> Data is encrypted in transit and at rest using industry-standard protocols</li>
                    <li><strong>Access Controls:</strong> Strict access controls and authentication mechanisms</li>
                    <li><strong>Regular Security Audits:</strong> Periodic security assessments and penetration testing</li>
                    <li><strong>Employee Training:</strong> Regular security awareness training for all staff</li>
                    <li><strong>Incident Response:</strong> Established procedures for handling security incidents</li>
                    <li><strong>Compliance Standards:</strong> Adherence to industry standards and best practices</li>
                  </ul>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    7. Data Retention and Deletion
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    We retain your information only for as long as necessary to fulfill the purposes outlined in this policy:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li><strong>Project Data:</strong> Retained for the duration of the project plus 7 years for legal compliance</li>
                    <li><strong>Communication Records:</strong> Retained for 3 years for business continuity and support</li>
                    <li><strong>Website Analytics:</strong> Retained for 2 years for service improvement</li>
                    <li><strong>Financial Records:</strong> Retained for 7 years as required by tax and accounting regulations</li>
                  </ul>
                  <p style={{ marginBottom: '1.5rem' }}>
                    Upon request, we will delete your personal information, subject to legal and contractual obligations.
                  </p>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    8. Your Rights and Choices
                  </h2>
                  <p style={{ marginBottom: '1rem' }}>
                    You have the following rights regarding your personal information:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li><strong>Access:</strong> Request a copy of your personal information</li>
                    <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
                    <li><strong>Deletion:</strong> Request deletion of your personal information</li>
                    <li><strong>Portability:</strong> Request transfer of your data to another service provider</li>
                    <li><strong>Objection:</strong> Object to processing of your information</li>
                    <li><strong>Restriction:</strong> Request restriction of processing in certain circumstances</li>
                    <li><strong>Withdrawal:</strong> Withdraw consent for data processing at any time</li>
                  </ul>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    9. International Data Transfers
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place, including:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li>Standard contractual clauses approved by relevant authorities</li>
                    <li>Adequacy decisions for countries with equivalent data protection standards</li>
                    <li>Certification schemes and codes of conduct</li>
                    <li>Regular assessments of data transfer mechanisms</li>
                  </ul>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    10. Cookies and Tracking Technologies
                  </h2>
                  <p style={{ marginBottom: '1rem' }}>
                    We use cookies and similar technologies to enhance your experience:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li><strong>Essential Cookies:</strong> Required for website functionality and security</li>
                    <li><strong>Analytics Cookies:</strong> Help us understand website usage and improve our services</li>
                    <li><strong>Preference Cookies:</strong> Remember your settings and preferences</li>
                    <li><strong>Marketing Cookies:</strong> Deliver relevant content and advertisements (with consent)</li>
                  </ul>
                  <p style={{ marginBottom: '1.5rem' }}>
                    You can control cookie settings through your browser preferences or our cookie consent manager.
                  </p>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    11. Children's Privacy
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    Our services are not intended for children under 16 years of age. We do not knowingly collect personal information from children under 16. If we become aware that we have collected such information, we will take steps to delete it promptly.
                  </p>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    12. Changes to This Privacy Policy
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    We may update this Privacy Policy from time to time to reflect changes in our practices, technology, legal requirements, or other factors. We will notify you of any material changes by:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li>Posting the updated policy on our website</li>
                    <li>Sending email notifications to registered users</li>
                    <li>Updating the "Last updated" date at the top of this policy</li>
                  </ul>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    13. Contact Us
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:
                  </p>
                  <div style={{
                    background: '#f8fafc',
                    padding: '1.5rem',
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0'
                  }}>
                    <p style={{ marginBottom: '0.5rem' }}>
                      <strong>Email:</strong> privacy@vallenai.com
                    </p>
                    <p style={{ marginBottom: '0.5rem' }}>
                      <strong>Address:</strong> Austin Texas, United States<br />
                      <small style={{color: '#94a3b8', fontStyle: 'italic'}}>
                        Temporary address - Not a physical office
                      </small>
                    </p>
                    <p style={{ margin: 0 }}>
                      <strong>Data Protection Officer:</strong> dpo@vallenai.com
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-5" style={{
        background: 'var(--gradient-hero)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Background Pattern */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 20% 80%, var(--accent-500) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, var(--accent-400) 0%, transparent 50%)
          `,
          opacity: '0.06',
          zIndex: 1
        }}></div>

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="row">
            <div className="col-lg-8 mx-auto text-center">
              <h3 style={{
                color: 'var(--primary-50)',
                marginBottom: '1rem',
                fontWeight: '700',
                fontSize: 'clamp(1.5rem, 3vw, 2rem)'
              }}>Questions About Our Privacy Policy?</h3>
              <p style={{
                color: 'rgba(255, 255, 255, 0.9)',
                marginBottom: '2rem',
                fontSize: '1.1rem'
              }}>
                We're committed to transparency and protecting your privacy. Contact our privacy team for any concerns or questions.
              </p>
              <Link to="/contact" style={{
                background: 'linear-gradient(135deg, var(--accent-500) 0%, var(--accent-600) 100%)',
                border: 'none',
                color: '#ffffff',
                padding: '1rem 2rem',
                borderRadius: '50px',
                fontWeight: '600',
                fontSize: '1rem',
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '200px',
                boxShadow: '0 8px 25px rgba(14, 165, 233, 0.4)',
                transition: 'all 0.3s ease'
              }}>
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPage; 